import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EAModal from "../../shared/Modal/EAModal";
import { LOGIN_PAGE } from "../../../routes";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const CalendarConfirmationModal: React.FC<IProps> = ({ isOpen, onClose }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleViewReservations = () => {
    navigate(LOGIN_PAGE);
    onClose();
  };

  return (
    <EAModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("rezerwacja_potwierdzona")}
      cancelButtonLabel={t("zamknij")}
      acceptButtonLabel={t("moje_rezerwacje")}
      onAccept={handleViewReservations}
    >
      <p>{t("rezerwacja_zostala_potwierdzona")}</p>
    </EAModal>
  );
};

export default CalendarConfirmationModal;
